import Factory from '@/client/factory';
import { Vue } from 'vue-property-decorator';
import ContextMenu from '@/components//ui/ContextMenu.vue';
import ConvertDuplicatesModal from '@/components/gacha/ConvertDuplicatesModal.vue';
import ConvertAllDuplicatesModal from '@/components/gacha/ConvertAllDuplicatesModal.vue';
import PoqLinkModal from '@/components/gacha/poq/PoqLinkModal.vue';
import ShopModal from '@/components/gacha/poq/ShopModal.vue';
import { StabfishFirebaseSocket } from './sf-firestore';
import { BvModal } from 'bootstrap-vue';
import { nonReact } from '@/util/nonReact';
import { EventEmitter } from '@pixi/utils';
import { Container } from 'pixi.js';
import { Scene } from 'pixi-animate';
import { SoundGroup } from '@/client/sound/SoundGroup';
import { SkinGachaControl } from '@/client/controls/skinGachaControl';

declare const sub: any;

export class Global {

	public static mainMenuIndex = 0;

	public static adsdk = '';

	public static width = document.documentElement.clientWidth;
	public static height = document.documentElement.clientHeight;

	public static $root: Vue;
	public static $bvModal: BvModal;
	public static hasMaintenance = StabfishFirebaseSocket.hasMaintenance;
	public static overlayGameIndicators = nonReact(new Container());
	public static overlayCanvasStage: Container;
	public static event = nonReact(new EventEmitter());
	public static rarityLabels = ['Common', 'Uncommon', 'Rare', 'Epic', 'Legendary'];
	public static rarityColors = ['#CCCCCC', '#F3C900', '#33CC99', '#3399FF', '#a863ff'];
	public static rarityRgbs = Global.rarityColors.map((c) => hexToRgb(c));
	public static convertDuplicatesModal: ConvertDuplicatesModal;
	public static convertAllDuplicatesModal: ConvertAllDuplicatesModal;
	public static poqLinkModal: PoqLinkModal;
	public static shopModal: ShopModal;
	public static contextMenu: ContextMenu;
	public static skinGachaControl: SkinGachaControl | null = null;

	public static partner = '';
	public static gameUrl = '';

	public static bgmSoundGroup = new SoundGroup();
	public static sfxSoundGroup = new SoundGroup();

	public static bgmControlSoundGroup = new SoundGroup();
	public static masterSoundGroup = new SoundGroup();
	public static isVideoPlaying = false;

	public static get appScale() {
		const width = document.documentElement.clientWidth;
		// const height = document.documentElement.clientHeight;
		let appScale = 1;
		const min = 550;
		// const wh = Math.min(width, height);
		const wh = width;
		if (wh < min) {
			appScale = wh / min;
		}
		return appScale;
	}
}
function hexToRgb(hex: string) {
	// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	hex = hex.replace(shorthandRegex, function(m, r, g, b) {
		return r + r + g + g + b + b;
	});

	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result ?
		parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16)
		: '255,255,255';
}

// window.onblur = () => {
// 	Tween.get(Global.masterSoundGroup, { override: true }).to(
// 		{ volume: 0 },
// 		1000,
// 	);
// };
// window.onfocus = () => {
// 	Tween.get(Global.masterSoundGroup, { override: true }).to(
// 		{ volume: 1 },
// 		1000,
// 	);
// };
setInterval(() => {
	if (document.visibilityState === 'visible' && !Global.isVideoPlaying) {
		if (Global.masterSoundGroup.volume < 1) {
			Global.masterSoundGroup.volume += 0.05;
			if (Global.masterSoundGroup.volume > 1) {
				Global.masterSoundGroup.volume = 1;
			}
		}
	} else {
		if (Global.masterSoundGroup.volume > 0) {
			Global.masterSoundGroup.volume -= 0.05;
			if (Global.masterSoundGroup.volume < 0) {
				Global.masterSoundGroup.volume = 0;
			}
		}
	}
}, 30);
